"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockHadespinRakeback = void 0;
const getMockHadespinRakeback = () => __awaiter(void 0, void 0, void 0, function* () {
    const rakeback = {
        user: "",
        hadesToClaimAmount: 0,
        claimTimestamp: 0,
        claimedAt: 0,
        claimed: false,
        lastTransactedAt: 0,
        placeholderOne: "",
        publicKey: ""
    };
    return rakeback;
});
exports.getMockHadespinRakeback = getMockHadespinRakeback;
